import React, { PureComponent, Fragment } from 'react';
import { VideoContext } from '../context/videoContext';
import VideoContentProvider from '../context/videoContentProvider';
import { MobileVideo } from '../mobileVideo/';
import Loading from '../loading/';
import Tips from '../tips/';
import styles from './index.css';
class Player extends PureComponent {
    render() {
        const { videoConfig, playermsg, playermsg: { background = '#000', tips, hasMargin = false, width = '100%', height = '100%' }, } = this.props;
        return (React.createElement(Fragment, null,
            React.createElement("div", { className: `${styles.videoContainer} ${hasMargin ? styles.containerMargin : null}`, style: { background, width, height }, id: "videoContainer" },
                React.createElement(VideoContentProvider, { initData: { videoConfig, playermsg } },
                    React.createElement(VideoContext.Consumer, null, context => {
                        if (context && context.videoReady) {
                            const voidCB = () => { };
                            const dispatch = context.dispatch || voidCB;
                            return (React.createElement(MobileVideo, { dispatch: dispatch, videoConfig: context.videoConfig || {}, playermsg: playermsg }));
                        }
                        return React.createElement(Loading, null);
                    }))),
            tips ? React.createElement(Tips, { content: tips }) : null));
    }
}
export default Player;
export { Player };
